
import { defineComponent } from 'vue'
import KnHint from '@/components/UI/KnHint.vue'

export default defineComponent({
    name: 'scorecards-table-hint',
    props: { hint: { type: String } },
    components: { KnHint }
})
